<template lang="pug">
  .h-100.w-100.position-absolute
    //-メッセージ表示
    .position-absolute#map-message(v-if="mapMessage!=''") 
      #message {{mapMessage}} 
      hr.mt-1.mb-1
      #rockName(v-if="!$parent.isExpanded") {{mapMessageRockName}}
      a(v-if="$parent.isExpanded" @click.prevent="resetExpand") {{mapMessageRockName}}
      .level {{mapMessageBlLevel}}
      .level {{mapMessageRcLevel}}
    //-拡大表示ボタン
    .position-absolute#expand-button(v-if="isCustumExpandCtlShow || isOffline")
      button(@click.prevent="mapExpand")
        //-広げるマークと閉じるマーク
        i.fas(v-bind:class="[this.$parent.isExpanded === true ? 'fa-compress-arrows-alt' : 'fa-expand-arrows-alt']")
    .position-absolute#location-button(v-if="isOffline")
      button(@click.prevent="myLocationShow")
        //-GPSマーク
        i.fas(class="fa-crosshairs")
    //-mapを表示するelement
    #map.h-100

</template>

<script>
import axios from 'axios'
var scriptjs = require("scriptjs")

export default {
  // 呼び出し元から受け取るプロパティ
  props: {
    rockyName: {type: String, default: ''},
    rockyLngLat: {type: String, default: ''},
    address: {type: String, default: ''},
    zoom: {type: Number,default: 6},
    //MAPのズームプロパティ
    gestureHandling:{type: String, default: 'cooperative'},
    isCsSpaCtlShow: {type: Boolean,default:false},
    //初期位置(デフォルトの中心地点は関東あたり)
    lat: {type: Number,default: 36.180669},
    lng: {type: Number,default: 138.651111},
    rockId: {type: Number,default: 0},
    rockName: {type: String, default: ''},
    //岩場データ
    rockyInfoApiData: {type: Array, default: () => {[]}}
  },
  data() {
    return {
      //岩場画面のフラグ
      isRockyInfo:true,

      rockyCenterMakerData:[],
      rockMakerData:[],
      parkingMakerData:[],
      restroomMakerData:[],
      facilityMakerData:[],
      approachPointMakerData:[],
      approachLineMakerData:[],
      climberReceptionMakerData:[],

      rockyMarkerList:[],
      rockMarerList:[],
      csSpaMarkerList:[],

      parkingMakerList:[],
      restroomMakerList:[],
      facilityMakerList:[],
      approachPointMakerList:[],
      climberReceptionMakerList:[],
      activeRockId : 0,
      activeRockName :'',

      rockNameLevelList:[],
      // デフォルト値
      map: null,
      isfullscreenControlShow:true,
      isCustumExpandCtlShow:false,
      // 表示エリアの自動調整用object
      bounds:null,
      // 岩の座標情報JSONファイルの値
      allRockLngLatJson:'',
      // 表示中のInfowindowを保持
      currentInfoWindow:null,
      // マーカーのアイコン
      ROCKY_ICON:process.env.VUE_APP_MATERIAL_URL + '/img/icon/icon-rocky.png',
      ROCK_ICON:process.env.VUE_APP_MATERIAL_URL + '/img/icon/icon_rock_point.png',
      ROCK_SELECTED_ICON:process.env.VUE_APP_MATERIAL_URL + '/img/icon/icon_rock_point_selected.png',
      CS_ICON:process.env.VUE_APP_MATERIAL_URL + '/img/icon/icon-cs.png',
      SPA_ICON:process.env.VUE_APP_MATERIAL_URL + '/img/icon/icon-spa.png',

      PARKING_ICON:process.env.VUE_APP_MATERIAL_URL + '/img/icon/icon-parking.png',
      RESTROOM_ICON:process.env.VUE_APP_MATERIAL_URL + '/img/icon/icon-restroom.png',
      FACILITY_ICON:process.env.VUE_APP_MATERIAL_URL + '/img/icon/icon-shop.png',
      APPROACH_POINT_ICON:process.env.VUE_APP_MATERIAL_URL + '/img/icon/icon-approach-point.png',
      CLIMBER_RECEPTION_ICON:process.env.VUE_APP_MATERIAL_URL + '/img/icon/icon-climber-reception.png',
      MY_LOCATION_ICON:process.env.VUE_APP_MATERIAL_URL + '/img/icon/my_location_point.png',

      // マーカーのサイズ
      ICON_SIZE_ROCK:null,
      ICON_SIZE_ROCK_SELECTED:null,
      ICON_SIZE_S:null,
      ICON_SIZE_ROCKY:null,
      ICON_SIZE_L:null,
      // アプローチラインの色
      APPROACH_LINE_STROKE_COLOR:'#FFCC80',
      APPROACH_LINE_FILL_COLOR:'#FFCC80',
      // フラグ制御に使用
      FLG_ROCKY:'rocky',
      FLG_ROCK:'rock',
      FLG_CS_SPA:'cs_spa',
      FLG_PARKING:'parking',
      FLG_RESTROOM:'restroom',
      FLG_FACILITY: 'facility',
      FLG_APPROACH_POINT:'approachPoint',
      FLG_APPROACH_LINE:'approachLine',
      FLG_CLIMBER_RECEPTION:'climberReception',

      // クラスターのアイコン
      CLUSTERER_IMG_PATH:'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      scrollY:0,
      beforeExpandMapHeight:0,
      // 現在地表示
      isMyLocationShow:false,
      // Map上のメッセージ
      mapMessage:'',
      mapMessageRockName:'',
      mapMessageBlLevel:'',
      mapMessageRcLevel:'',
      MESSAGE_NO_LATLNG: '座標情報がありません',
      isGoogleFullscreenControlShow : true,
      rockyMarkerLat:0,
      rockyMarkerLng:0,
      currentLocation: null,
      // ラベルボタン
      isLabelShow: false,
      LABEL_SHOW_LEVEL: 18,
      LABEL_HIDE_LEVEL: 17,

      isOffline: false,
    }
  },
  created() {
    //GoogleMapAPI呼び出し
    scriptjs(
      'https://maps.googleapis.com/maps/api/js?key=' + process.env.VUE_APP_GOOGLE_MAPS_API_KEY + '&libraries=geometry&region=JP&language=ja',
      'loadGoogleMap'
    )
    //マップロード処理
    scriptjs.ready("loadGoogleMap", this.createdProcess)
    // オフラインかチェック
    if(!navigator.onLine) {
      this.isOffline = true;
    }
  },
  // インスタンス破棄前
  beforeDestroy() {
    // ブラウザバックイベントを解除
    window.removeEventListener("popstate", this.popstateProcess)
  },
  destroyed(){
    // MAPを最大表示している状態でヘッダーナビボタンから画面遷移する場合の対策
    // PCでのスクロール禁止解除
    document.removeEventListener("mousewheel", this.scroll_control, { passive: false });
    // スマホでのタッチ操作でのスクロール禁止解除
    document.removeEventListener('touchmove', this.scroll_control, { passive: false });
  },
  // メソッド
  methods: {
    //-------------------------------------
    // 地図にダウンロードしたマップタイルを
    // オーバーレイする
    //-------------------------------------
    overlayMapTile(mapUrl) {
      console.log("Overlay")
      const offlineMapType = new window.google.maps.ImageMapType({
        getTileUrl: function (coord, zoom) {
          var url = mapUrl
            .replace("{x}", coord.x)
            .replace("{y}", coord.y)
            .replace("{z}", zoom);
          return url;
        },
        tileSize: new google.maps.Size(256, 256),
        maxZoom: 18,
        minZoom: 13,
        name: "offline_map",
      });
      this.map.overlayMapTypes.insertAt(0, offlineMapType);

    },
    //-------------------------------------
    // ダウンロードする地図の範囲を取得する
    //-------------------------------------
    getMapCoordinate() {
      let maxLat = this.rockMakerData.reduce((a, b) => a.lat > b.lat ? a : b)
      let minLat = this.rockMakerData.reduce((a, b) => a.lat < b.lat ? a : b)
      let maxLng = this.rockMakerData.reduce((a, b) => a.lng > b.lng ? a : b)
      let minLng = this.rockMakerData.reduce((a, b) => a.lng < b.lng ? a : b)
      const coordinate = {
        "maxLat": maxLat.lat,
        "minLat": minLat.lat,
        "maxLng": maxLng.lng,
        "minLng": minLng.lng
      }
      return coordinate
    },
    //-------------------------------------
    // MAPのロード処理
    //-------------------------------------
    async createdProcess() {
    
      //親画面から受け取った座標情報
      let wkLat = this.lat
      let wkLng = this.lng
      let wkZoom = this.zoom

      if(this.$route.name=='rockyInfo_:rockyId'){
        this.isRockyInfo = true
      }else{
        this.isRockyInfo = false
      }

      this.mapMessage = ''
      this.mapMessageRockName = ''
      this.mapMessageBlLevel = ''
      this.mapMessageRcLevel = ''

      //googleMapの呼び出し後に定数をセットする
      //(マーカー画像は189×224)縦は横に1.185倍する
      this.ICON_SIZE_ROCK = new google.maps.Size(30,33)
      this.ICON_SIZE_ROCK_SELECTED = new google.maps.Size(33,35)
      this.ICON_SIZE_ROCKY = new google.maps.Size(42,40)
      this.ICON_SIZE_S = new google.maps.Size(27,32)
      this.ICON_SIZE_L = new google.maps.Size(40,48)

      //岩場情報をセットする
      const rockyInfo = this.rockyInfoApiData[0].rockyInfo

      if(rockyInfo.parkingList != undefined){
        this.parkingMakerData = rockyInfo.parkingList
      }
      if(rockyInfo.restroomList != undefined){
        this.restroomMakerData = rockyInfo.restroomList
      }
      if(rockyInfo.facilityList != undefined){
        this.facilityMakerData = rockyInfo.facilityList
      }
      if(rockyInfo.approachPointList != undefined){
        this.approachPointMakerData = rockyInfo.approachPointList
      }
      if(rockyInfo.approachLineList != undefined){
        this.approachLineMakerData = rockyInfo.approachLineList
      }
      if(rockyInfo.climberReceptionList != undefined){
        this.climberReceptionMakerData = rockyInfo.climberReceptionList
      }

      //ブラウザバックの検知を追加
      window.history.pushState(null, null, null);
      window.addEventListener("popstate", this.popstateProcess)

      //岩場、岩それぞれのmarkerオブジェクトリストを作成する
      await this.getAndSetMakerDataList() 

      //ブラウザ情報取得
      var ua = navigator.userAgent.toLowerCase();
      //iOSの場合場合はgoogleMapのフルスクリーン表示がサポートされていないため、
      //独自の拡大表示ボタンを表示する。
      if(ua.indexOf("iphone") !== -1 || ua.indexOf("ipad") !== -1){
        //独自ボタン
        this.isCustumExpandCtlShow = true
        //googleMap標準のフルスクリーンボタンを非表示にする。
        //(二重表示にならないようにする為の対策)
        this.isGoogleFullscreenControlShow = false
      }

      //mapオブジェクト作成
      //console.log('■■■■new google.maps.Map()')
      this.map = new google.maps.Map(document.getElementById("map"), {
        //中心座標
        center: { lat: wkLat, lng: wkLng },
        //zoo,
        zoom: wkZoom,
        //スクロール設定
        gestureHandling: this.gestureHandling, 
        //マップタイプ(地図、航空写真) コントロール
        mapTypeControl: true, 
        //全画面表示コントロール
        fullscreenControl: this.isGoogleFullscreenControlShow,
        //ストリートビュー コントロール
        streetViewControl: false, 
        //ズーム コントロール
        zoomControl: false, 
        //オプション
        mapTypeControlOptions : {
          style : google.maps.MapTypeControlStyle.DROPDOWN_MENU
        },
        //HYBRID,ROADMAP,SATELLITE,TERRAIN
        mapTypeId: google.maps.MapTypeId.ROADMAP
      })

      // Maoの初期表示はグレースケール表示
      var mapStyle = [ {
          "stylers": [ {
          "saturation": -100
          } ]
      } ];
      var mapType = new google.maps.StyledMapType(mapStyle);
      this.map.mapTypes.set( 'GrayScaleMap', mapType);
      this.map.setMapTypeId( 'GrayScaleMap' );
      // オフライン時は衛星地図タイプに設定する
      if(!navigator.onLine) this.map.setMapTypeId( 'Satellite' );

      // Map種別切り替え判定
      this.map.addListener("maptypeid_changed", () => {
        this.rockMarerList.forEach((marker) => {
          var label = marker.getLabel();
          if(label === undefined) return;
          switch (this.map.getMapTypeId()) {
            case "roadmap":
            case "terrain":
              label.color = "black";
              marker.setLabel(label);
            break;
            case "hybrid":
            case "satellite":
              label.color = "white";
              marker.setLabel(label);
              break;
            default:
              label.color = "black";
              break;
          }
        });
      });

      // Zoomレベルの切り替え判定
      this.map.addListener("zoom_changed", async () => {
        const level = this.map.getZoom()
        if(level >= this.LABEL_SHOW_LEVEL && !this.isLabelShow) {
          await this.switchLabel()
          this.changeRockMarkerActive(this.activeRockId)
        }else if(level == this.LABEL_HIDE_LEVEL){
          this.isLabelShow = true
          await this.switchLabel()
          this.changeRockMarkerActive(this.activeRockId)
        }
      })

      //googleMap標準のフルスクリーンボタンを表示する場合は、イベントリスナーをセットする
      if(this.isGoogleFullscreenControlShow){
        
        //フルスクリーンボタンのelement
        const elementToSendFullscreen = this.map.getDiv().firstChild;

        //フルスクリーンボタンのイベントリスナー
        document.onwebkitfullscreenchange =
          document.onmsfullscreenchange =
            document.onmozfullscreenchange =
              document.onfullscreenchange = () => {
                //フルスクリーン表示の状態を判定する
                if(document.fullscreenElement ||  document.webkitFullscreenElement ||
                  document.mozFullScreenElement || document.msFullscreenElement == elementToSendFullscreen)
                {
                  this.$parent.isExpanded = false
                }else{
                  this.$parent.isExpanded = true
                }

                this.mapExpand()
              }
      }

      //this.bounds初期化
      this.initBoundsList()

      //付加情報のマーカー、ライン表示
      this.showParkingMarker()
      this.showRestroomMaker()
      this.showFacilityMaker()
      this.showApproachPointMaker()
      this.showApproachLine()
      this.showClimberReceptionMakeMaker()

      //コンビニ・温泉表示ボタン
      if(this.isCsSpaCtlShow){
        this.makeCsSpaControl()
      }

      //現在位置表示ボタン、ラベル切り替えボタンは常に表示する
      this.makeMyLocationControl()
      this.makeMyLabelControl()

      // マーカーを表示する
      if(this.isRockyInfo){
        //岩場画面の場合
        if(this.rockyInfoApiData[0].imgList[0].path.match('no_img')){
          //岩場マーカー表示
          this.showRockyCenterMarker(true,this.ROCKY_ICON)

        }else{
          //岩マーカー表示
          this.showRockMarker(false)
        }

        return
      }else{ 
        if(this.rockMakerData.length == 0){
          //岩の座標が存在しない場合は岩場のマーカーを表示する
          this.showRockyCenterMarker(true,this.ROCKY_ICON)
        }else{
          this.showRockMarker(true)
          this.changeRockMarkerActive(null)
        } 

        // Mapを航空写真にする
        this.changeMapTypeId('HYBRID')
      }
    },
    //----------------------------------------
    // 地図上のラベルの表示を切り替える
    //----------------------------------------
    async switchLabel() {
      await this.deletAllMarker()

      this.isLabelShow = this.isLabelShow ? false : true
      this.showRockMarker(true)
      this.makeMyLabelControl()
    },
    //------------------------------------------------
    // 岩場、岩のマーカー用データListを作成する
    //------------------------------------------------
    async getAndSetMakerDataList(){
      
      this.rockyCenterMakerObj = []
      this.rockMakerData = []

      //岩場中心座標のマーカーオブジェクト
      let retrnArray = this.splitLngLat(this.rockyLngLat)
      let wkLat = retrnArray[0]
      let wkLlng = retrnArray[1]

      this.rockyCenterMakerData.push({
        lat : wkLat,
        lng : wkLlng,
        title: this.rockyName,
        subtitle: this.level,
        containt: this.address,
        url: rockyId,
        infoWindowString:''
      })

      //岩場マーカーの座標
      this.rockyMarkerLat = wkLat
      this.rockyMarkerLng = wkLlng

      //岩の座標JSONを取得してthis.allRockLngLatJsonにセット
      await this.getRockLongLatJsonFromApi()

      //対象の岩の情報を抽出する
      const rockyId = this.$route.params.rockyId
      let targetRockyAllRockLngLatList = this.allRockLngLatJson.filter(record => record.rpId == rockyId)

      //岩のマーカーListを作成する
      let wkList = []
      targetRockyAllRockLngLatList.forEach((target) => {

        //レベル情報を抽出する
        let targetRockInfo = this.$parent.rockList.filter(record => record.id == target.id)[0]

        let wkName = target.name == '' ? "（岩名なし）" : target.name

        //吹き出しのHTML生成
        let wkContentString = '<div style="font-size: 1rem; font-weight:bold; color: #004170 ">' + wkName + '</div>'
        if(targetRockInfo.blLevel != "" && targetRockInfo.blLevel != undefined ){
          wkContentString +=  '<div>'+ targetRockInfo.blLevel +'</div>'
        }
        if(targetRockInfo.rcLevel != "" && targetRockInfo.rcLevel != undefined ){
          wkContentString +=  '<div>'+ targetRockInfo.rcLevel +'</div>'
        }

        //rockMakerDataとは別に、処理に使用する項目Listを作成する。
        this.rockNameLevelList.push({
          id : target.id,
          rockName : wkName,
          blLevel : targetRockInfo.blLevel,
          rcLevel : targetRockInfo.rcLevel,
        })

        //座標情報が存在する場合のみマーカーオブジェクトを生成
        if(target.lat !=null && target.lng!=null){
          wkList.push({
            lat: target.lat,
            lng: target.lng,
            title: wkName,
            subtitle: '',
            containt: '',
            url: target.id,
            rockId: target.id,
            rockName: wkName,
            blLevel : targetRockInfo.blLevel,
            rcLevel : targetRockInfo.rcLevel,
            infoWindowString: wkContentString
          })
        }
      })
      this.rockMakerData = wkList

      return
    },
    //--------------------------
    //岩の座標情報JSONファイル取得
    //--------------------------
    async getRockLongLatJsonFromApi(){
      //岩場情報JSON
      let jsonUrl = process.env.VUE_APP_MATERIAL_URL + '/rockLongLatList.json'
      await axios
        .get(jsonUrl)
        .then(response => {
          this.allRockLngLatJson = response.data
        })
        .catch(function (error) {alert(error)})

      //データが0件の場合
      if(this.allRockLngLatJson.length == 0){
        //ここでデータが取得できない場合は、データ不正
        await this.asyncDialog('システムエラー：岩マップ情報を取得できませんでした')
        return
      }
    },
    //---------------------------------------
    // 岩場マーカーの作成
    //---------------------------------------
    async showRockyCenterMarker(){
      //表示中のマーカーを削除
      this.deletAllMarker()

      //岩場のマーカーを表示+rockyMarkerListにセット
      this.addMarker(this.rockyCenterMakerData,false,this.ROCKY_ICON,this.FLG_ROCKY,false)

      //イベントリスナー設定
      this.rockyMarkerList.forEach((marker) => {
        // マーカークリックのイベントリスナー
        marker.addListener("click", () => {
          // 2022/07/07 追加
          marker.icon.labelOrigin = new google.maps.Point(10, 40);
          //岩の座標が存在する場合セットする
          if(this.rockMakerData.length > 0){
            // 岩のマーカーを表示する
            this.showRockMarker(true)
          }
        })
        //MAPの中心位置を岩場にする
        this.setCenter(marker.position.lat(),marker.position.lng())
      })
    },
    //-------------------------------------
    // 岩マーカーの作成
    //-------------------------------------
    async showRockMarker(isMakerDelete){

      //岩の座標が1つもない場合は岩場アイコンを表示したままにする
      if(this.rockMakerData.length == 0){
        this.showRockyCenterMarker()
        return
      }

      if(isMakerDelete){
        //表示中のマーカーを削除
        this.deletAllMarker()

        //コンビニ・温泉表示ボタンの削除
        this.deleteScSpaButton()
      }

      this.$parent.isRockMakerShowOnMap = true

      //マーカーリストを初期化
      this.rockMarerList = []

      //岩のマーカーを表示+rockyMarkerListにセット
      this.addMarker(this.rockMakerData,false,this.ROCK_ICON,this.FLG_ROCK,false)

      //岩マーカーのイベントリスナー設定
      this.rockMarerList.forEach((marker) => {
        // 2022/07/07 追加
        marker.icon.labelOrigin = new google.maps.Point(10, 40);
        // マーカークリックのイベントリスナー
        marker.addListener("click", () => {

          if(this.$route.name != 'rockyInfo_:rockyId'){
            this.pushRockMarkerProcess(marker.id,marker.name)
          }

          //リンク表示有りのinfoWindowを表示する
          this.changeRockMarkerActive(marker.id)
          // 2022/07/07 追加
          marker.icon.labelOrigin = new google.maps.Point(10, 40);
        })
      })

    },
    //------------------------------
    //コンビニ・温泉表示ボタンの削除
    //------------------------------
    deleteScSpaButton(){
      if(this.map.controls[google.maps.ControlPosition.BOTTOM_CENTER]){
        this.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].clear()
      }
    },
    //---------------------------------------
    //表示中の全てのマーカーの削除
    //---------------------------------------
    async deletAllMarker(){
      //岩場マーカー削除
      this.rockyMarkerList.forEach(function (marker, idx) { marker.setMap(null) })
      //岩マーカー削除
      this.rockMarerList.forEach(function (marker, idx) { marker.setMap(null) }) 
    },
    //--------------------------
    // 岩マーカー押下時の処理
    //--------------------------
    pushRockMarkerProcess(rockId,rockName){

      //ルート一覧のデータ取得とセット
      this.$parent.getRouteDataList(rockId)

      //Mapのサイズで動作を制御
      if(this.$parent.isExpanded){

        //対象の岩IDがMap最大化前と同じ場合は、最大化を解除して終了
        if(rockId == this.activeRockId){
          this.mapExpand()
          return 
        }

        //対象の岩マーカーのinfowindowを表示する
        this.changeRockMarkerActive(rockId)
      }else{
        //Mapを最大化表示していない場合は、画面遷移する
        this.$router.push({ 
          name: 'rockyInfo_:rockyId_:rockId', 
          params: { 
            rockyId: this.$route.params.rockyId, 
            rockId:rockId,
            rockName:rockName,
            rockyMasterData:this.rockyMasterData,
          }
        },() => {},() => {})
      }

    },
    //---------------------------------------------------
    //パラメータのListをマーカーObjectのリストに変換して返す
    //---------------------------------------------------
    makeMarkerObjList(paramList,isUseAnimation,iconPath){
      let returnList = []
      
      paramList.forEach((target) => {

        //マーカーオブジェクトを生成
        let marker = this.createMakerObject(target,isUseAnimation,iconPath)

        returnList.push(marker)
      })

      return returnList
    },
    //------------------------------
    // MAP上のマーカー作成
    //------------------------------
    addMarker(paramList,isUseAnimation,iconPath,markerType,isFitBounds){

      switch(markerType) {
        //岩場
        case this.FLG_ROCKY:
          this.rockyMarkerList = []  
          break;
        //岩
        case this.FLG_ROCK:
          this.rockMarerList = [] 
          break;
        //コンビニ・温泉
        case this.FLG_CS_SPA:
          //コンビニ、温泉の場合は同一のリストにデータを追加する為、List初期化しない。
          //this.csSpaMarkerList = [] 
          break;
        //駐車場
        case this.FLG_PARKING:
          this.parkingMakerList = []
          break;
        //お手洗い
        case this.FLG_RESTROOM:
          this.restroomMakerList = []
          break;
        //周辺施設
        case this.FLG_FACILITY:
          this.facilityMakerList = []
          break;
        //アプローチ入口
        case this.FLG_APPROACH_POINT:
          this.approachPointMakerList = []
          break;
        //入山申請所
        case this.FLG_CLIMBER_RECEPTION:
          this.climberReceptionMakerList = []
          break;
      }


      paramList.forEach((target) => {
        //マーカーオブジェクトを生成
        let marker = this.createMakerObject(target,isUseAnimation,iconPath)

        //座標がないマーカー情報の場合の考慮
        if(marker==null || marker==undefined){
          return
        }

        //MAPの表示エリア調整用のListに追加する
        this.bounds.extend(new google.maps.LatLng(target.lat, target.lng))

        switch(markerType) {
          //岩場
          case this.FLG_ROCKY:
            this.rockyMarkerList.push(marker) 
            break;
          //岩
          case this.FLG_ROCK:
            this.rockMarerList.push(marker) 
            break;
          //コンビニ・温泉
          case this.FLG_CS_SPA:
            this.csSpaMarkerList.push(marker)
            break;
          //駐車場
          case this.FLG_PARKING:
            this.parkingMakerList.push(marker)
            break;
          //お手洗い
          case this.FLG_RESTROOM:
            this.restroomMakerList.push(marker)
            break;
          //周辺施設
            case this.FLG_FACILITY:
            this.facilityMakerList.push(marker)
            break;
          //アプローチ入口
          case this.FLG_APPROACH_POINT:
            this.approachPointMakerList.push(marker)
            break;
          //入山申請所
          case this.FLG_CLIMBER_RECEPTION:
            this.climberReceptionMakerList.push(marker)
            break;
        }

        //MAPの表示エリアを調整する
        if(isFitBounds){
          this.map.fitBounds(this.bounds)
        }
      })
    },
    //-----------------------------------
    // InfoWindowオブジェクトを生成して返す
    //-----------------------------------
    makeInfoWindow(infoWindowString){
      return new google.maps.InfoWindow({
        content: infoWindowString,
        maxWidth: 350
      })
    },
    //-----------------------------------
    // MapTypeを変更する
    //-----------------------------------
    changeMapTypeId(type){
      switch(type) {
        case "HYBRID":// ハイブリッド
          this.map.setMapTypeId(google.maps.MapTypeId.HYBRID);
          break
        case "ROADMAP":// 地図
          this.map.setMapTypeId(google.maps.MapTypeId.ROADMAP);
          break
        case "SATELLITE":// 衛星写真
          this.map.setMapTypeId(google.maps.MapTypeId.SATELLITE);
          break
        case "TERRAIN":// 地形
          this.map.setMapTypeId(google.maps.MapTypeId.TERRAIN);
          break
      }
    },
    //-----------------------------------
    // 表示倍率(zoom)を変更する
    //-----------------------------------
    changeMapZoom(mag){
      this.map.setZoom(mag)
    },
    //-------------------------------------------------------------
    // 特定の岩IDのマーカーを強制的に選択状態して、Infowindowを表示する
    //-------------------------------------------------------------
    changeRockMarkerActive(rockId){
      //初期化
      this.mapMessage = ''
      this.mapMessageRockName = ''
      this.mapMessageBlLevel = ''
      this.mapMessageRcLevel = ''

      //岩場内に岩の座標が1つもない場合
      if(this.rockMakerData.length == 0){
        return
      }

      //地図を最大化している状態のみrockIdがセットされている。その他はnull
      if(rockId == null){
        rockId = this.$route.params.rockId
      }

      //表示中のInfoWindowを閉じる
      if (this.currentInfoWindow) {
        this.currentInfoWindow.close();
      }

      //岩場マーカー削除
      this.rockyMarkerList.forEach(function (marker, idx) { marker.setMap(null) })
      //表示中の岩マーカーを一旦"未選択"の状態にする
      this.rockMarerList.forEach((targetMarker) => {

        targetMarker.setIcon(
          {
            url:this.ROCK_ICON,
            scaledSize:this.ICON_SIZE_ROCK
          }
        )
        // 2022/07/07 追加
        targetMarker.icon.labelOrigin = new google.maps.Point(10, 40);
      })

      // Active対象のマーカー情報を抽出する
      let wkMarkerObj = this.rockMarerList.filter(marker => marker.id == rockId)

      // 岩の座標情報が存在しない場合
      if(wkMarkerObj.length == 0){
        //岩の名前、レベルを格納したListから対象を抽出する
        let wkObj = this.rockNameLevelList.filter(rock => rock.id == rockId)[0]

        setTimeout(() => {
          this.mapMessage = this.MESSAGE_NO_LATLNG
          this.mapMessageRockName = wkObj.rockName
          this.mapMessageBlLevel = wkObj.blLevel
          this.mapMessageRcLevel = wkObj.rcLevel
          this.activeRockId = rockId
          this.activeRockName = wkObj.rockName
        }, 100)
        return
      }

      // マーカーアイコンを選択中のものにする
      wkMarkerObj[0].setIcon(
        {
          url:this.ROCK_SELECTED_ICON,
          scaledSize:this.ICON_SIZE_ROCK_SELECTED,
          labelOrigin: new google.maps.Point(10, 40)
        }
      )

      // 対象の岩情報を抽出する
      let targetRockInfo = this.rockMakerData.filter(rock => rock.rockId == rockId)[0]

      this.activeRockId = rockId
      this.activeRockName = targetRockInfo.rockName

      // infowindowのHTML生成
      let wkContentString = ''
      
      if(this.$parent.isExpanded || this.$route.name == 'rockyInfo_:rockyId'){
        //地図が拡大表示されている場合or岩場画面び場合岩名をリンクにする
        //<a>タブを利用するとclickイベントの挙動が問題ありのため、buttonで実装
        wkContentString += '<button id="link-button" style="background-color:#fff; border:none; font-size: 1rem; color: #004170; font-weight:bold; text-decoration: underline;"  >' + targetRockInfo.rockName + '</button>'
      }else{
        //地図がデフォルト表示の場合は、ラベル表示する
        wkContentString += '<div style="font-size: 1rem; font-weight:bold; color: #004170 ">' + targetRockInfo.rockName + '</div>'
      }

      //ボルダーレベルが設定されている場合、infoWindowに表示する
      if(targetRockInfo.blLevel != "" && targetRockInfo.blLevel != undefined ){
        wkContentString +=  '<div>'+ targetRockInfo.blLevel +'</div>'
      }
      //ロープレベルが設定されている場合、infoWindowに表示する
      if(targetRockInfo.rcLevel != "" && targetRockInfo.rcLevel != undefined ){
        wkContentString +=  '<div>'+ targetRockInfo.rcLevel +'</div>'
      }

      let infowindow = this.makeInfoWindow(wkContentString)

      //Mapが最大化されている場合のクリックイベント
      //infoWindowのcontentにセットしたhtmlではクリックイベントが効かないため、
      //addEventListenerでセットする。
      //https://hryktrd.hatenablog.com/entry/2019/03/26/100925
      if(this.$parent.isExpanded || this.$route.name == 'rockyInfo_:rockyId'){
        infowindow.addListener('domready', () => {
          document.getElementById('link-button').addEventListener('click', () => {

            //Mapが最大表示されている場合は解除する
            if(this.$parent.isExpanded){

              this.mapExpand(rockId) 

              if(this.isGoogleFullscreenControlShow){
                //GoogleMap標準のフルスクリーンボタンが表示されている場合の解除
                if (document.exitFullscreen) {
                  document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                  document.webkitExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                  document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                  document.msExitFullscreen();
                }
              }
            }

            //対象の岩IDがMap最大化前と同じ場合
            if(rockId == this.activeRockId && this.$route.name != 'rockyInfo_:rockyId'){
              //Infowindowをリンク無し表示にする
              this.changeRockMarkerActive()
              return 
            }

            //ルート画面を表示する
            this.$router.push({ 
              name: 'rockyInfo_:rockyId_:rockId', 
              params: { 
                rockyId: this.$route.params.rockyId, 
                rockId:this.activeRockId,
                rockName:this.activeRockName,
                rockyMasterData:this.rockyMasterData,
              }
            })

          });
        });
      }

      this.currentInfoWindow = infowindow

      //infowindowをオープンする
      infowindow.open(this.map, wkMarkerObj[0])

      //選択した岩を中心にする
      //this.setCenter(targetMarker.position.lat(),targetMarker.position.lng())

      return
    },
    resetExpand(){
      if(this.$parent.isExpanded){
        this.mapExpand()
      }
    },
    splitLngLat(str){
      //経度緯度を分割
      var rockyLongLat = {}
      try {
        rockyLongLat = str.split(',')
      } catch(err) {
        return null
      } 

      let lat = parseFloat(rockyLongLat[0])
      let lng = parseFloat(rockyLongLat[1])
      let retrnArray = [lat,lng]
    
      return retrnArray
    },

    initBoundsList(){
      this.bounds = new google.maps.LatLngBounds()
      //常に岩場中心のマーカーが範囲に含まれるようListに追加する
      this.bounds.extend(new google.maps.LatLng(this.lat, this.lng))
    },
    extendBoundsList(lat,lng){
      this.bounds.extend(new google.maps.LatLng(lat, lng))
    },

    //------------------------------------------------------------
    // コンビニ、温泉のマーカー押下時に表示する吹き出しのHTMLを作成する
    //------------------------------------------------------------
    makeInfoWindowHtmlString(title,subtitle,containt,url) {

      let urlStr = 'GoogleMapで見る'    

      //マーカークリック時の吹き出しに表示するHTML
      let returnStr = 
      '  <div style="font-size: 1rem; font-weight:bold;">' + 
          title +
      '    <span style="color: #959EA7; text-align: right;">' + subtitle + '</span>' + 
      '  </div>'+
      '  <div style="color: #3A5263;">' + containt + '</div>'+
      '  <div>'+
      '    <a href="' + url + '" target="_blank" style="text-align: right; text-decoration: underline;">' + urlStr + '</a>'
      '  </div>'
      return returnStr
    },
    //----------------------------
    //地図の中心座標を移動変更する
    //----------------------------
    setCenter(lat,lng){
      const latlng = new google.maps.LatLng(lat, lng)
      this.map.setCenter(latlng)
    },
    asyncDialog(msg) {
      return new Promise((resolve) => {
        this.$bvModal.msgBoxOk(msg, {
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
        .then(value => {
          resolve(value)
        })
        .catch(err => {
          // An error occurred
        })
      })
    },

    //---------------------------------------
    //MAP上に表示（コンビニ・温泉ボタン）
    //---------------------------------------
    makeCsSpaControl(){

      if(document.getElementById("csSpaControl") != null){
        //既に表示されている場合は何もしない
        return
      }

      var csSpaDiv = document.createElement('div')
      //コントロール外枠
      csSpaDiv.id = 'csSpaControl'
      csSpaDiv.style.width = '160px'
      csSpaDiv.style.padding = '5px 0'
      //コンビニ・温泉表示ボタン
      var scSpaButton = document.createElement('div')
      scSpaButton.style.height = '27px'
      scSpaButton.style.marginBottom = '0.7rem'
      scSpaButton.style.backgroundColor = '#0664a9'
      scSpaButton.style.color = '#fff'
      scSpaButton.style.cursor = 'pointer'
      scSpaButton.style.display = 'flex'
      scSpaButton.style.justifyContent = 'center'
      scSpaButton.style.alignItems = 'center'
      scSpaButton.style.borderRadius = '5px'
      scSpaButton.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px'
      scSpaButton.title = 'コンビニ・温泉を表示'
      csSpaDiv.appendChild(scSpaButton)

      var scSpaButtonText = document.createElement('div')
      scSpaButtonText.style.fontSize = '0.7rem'
      scSpaButtonText.innerHTML = '<b><i class="fas fa-map-marker-alt"></i>  コンビニ・温泉を表示</b>'
      scSpaButton.appendChild(scSpaButtonText)

      csSpaDiv.index = 2
      /* カスタムコントロールを地図の右上に配置 */
      this.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(csSpaDiv)

      //温泉ボタン押下のイベントリスナー
      google.maps.event.addDomListener(scSpaButton, "click", () => {
        //親画面のメソッド呼び出し
        //this.$parent.addCsSpaOnMap()
        this.addCsSpaMarker()      
      })
    },
    //-------------------------------------------------
    // コンビニと温泉のマーカー作成
    //-------------------------------------------------
    addCsSpaMarker() {

      //親画面で保持している情報を使用して、マーカー用のListを作成する
      let paramCsList = this.makeCsSpaList(this.$parent.csList,true)
      let paramSpaList = this.makeCsSpaList(this.$parent.spaList,false)

      //this.bounds初期化
      this.initBoundsList()
      paramCsList.forEach((target) => {this.extendBoundsList(target.lat,target.lng)})
      paramSpaList.forEach((target) => {this.extendBoundsList(target.lat,target.lng)})

      //コンビニ・温泉のマーカーを作成する
      this.addMarker(paramCsList,true,this.CS_ICON,this.FLG_CS_SPA,true)
      this.addMarker(paramSpaList,true,this.SPA_ICON,this.FLG_CS_SPA,true)

      //イベントリスナー設定
      this.csSpaMarkerList.forEach((marker) => {
        let infowindow = this.makeInfoWindow(marker.infoWindowString)
        // マーカークリックのイベントリスナー
        marker.addListener("click", () => {
          //表示中のInfoWindowを閉じる
          if (this.currentInfoWindow) {
            this.currentInfoWindow.close();
          }
          this.currentInfoWindow = infowindow
          infowindow.open(this.map, marker)
        })
      })

      //全てのコンビニ・温泉マーカーが範囲内に表示されるよう調整する
      this.map.fitBounds(this.bounds)

    },

    //---------------------------------------
    // 駐車場マーカーの表示
    //---------------------------------------
    async showParkingMarker(){

      //APIから取得したListにInfowindowの値を追加する。
      this.parkingMakerData.forEach((target) => {
        target.infoWindowString = '<div style="font-size: 1rem; font-weight:bold;">' + target.name + '</div>'
        target.infoWindowString +='<div style="color: #3A5263;">' + target.units + '</div>'
        target.infoWindowString +='<div style="color: #3A5263;">' + target.info + '</div>'
      })

      //駐車場のマーカーを表示
      this.addMarker(this.parkingMakerData,false,this.PARKING_ICON,this.FLG_PARKING,true)

      //イベントリスナー設定
      this.parkingMakerList.forEach((marker) => {

        //infoWindowStringが存在しない場合はエラーを防止するためreturn
        if(marker == null || marker.infoWindowString == undefined || marker.infoWindowString == '' || marker.infoWindowString == null){
          return
        }

        let infowindow = this.makeInfoWindow(marker.infoWindowString)

        // マーカークリックのイベントリスナー
        marker.addListener("click", () => {
          // 2022/07/07 追加
          marker.icon.labelOrigin = new google.maps.Point(10, 40);
          //表示中のInfoWindowを閉じる
          if (this.currentInfoWindow) {
            this.currentInfoWindow.close();
          }
          this.currentInfoWindow = infowindow
          infowindow.open(this.map, marker)
        })

        //MAPの中心位置を岩場にする
        this.setCenter(marker.position.lat(),marker.position.lng())

      })
    },

    //---------------------------------------
    // お手洗いマーカーの表示
    //---------------------------------------
    async showRestroomMaker(){

      //APIから取得したListにInfowindowの値を追加する。
      this.restroomMakerData.forEach((target) => {
        target.infoWindowString = '<div style="font-size: 1rem; font-weight:bold;">' + target.name + '</div>'
        target.infoWindowString += '<div style="color: #3A5263;">' + target.info + '</div>'
      })

      //お手洗いのマーカーを表示
      this.addMarker(this.restroomMakerData,false,this.RESTROOM_ICON,this.FLG_RESTROOM,true)

      //イベントリスナー設定
      this.restroomMakerList.forEach((marker) => {

        let infowindow = this.makeInfoWindow(marker.infoWindowString)

        // マーカークリックのイベントリスナー
        marker.addListener("click", () => {
          // 2022/07/07 追加
          marker.icon.labelOrigin = new google.maps.Point(10, 40);
          //表示中のInfoWindowを閉じる
          if (this.currentInfoWindow) {
            this.currentInfoWindow.close();
          }
          this.currentInfoWindow = infowindow
          infowindow.open(this.map, marker)
        })
        //MAPの中心位置を岩場にする
        this.setCenter(marker.position.lat(),marker.position.lng())

      })
    },

    //---------------------------------------
    // 周辺施設マーカーの表示
    //---------------------------------------
    async showFacilityMaker(){

      //APIから取得したListにInfowindowの値を追加する。
      this.facilityMakerData.forEach((target) => {
        target.infoWindowString = '<div style="font-size: 1rem; font-weight:bold;"><a href="' + target.url + '" target="_blank" rel="noopener noreferrer">' + target.name + '</a></div>'
        target.infoWindowString += '<div style="color: #3A5263;">営業時間:' + target.businessHours + '</div>'
        target.infoWindowString += '<div style="color: #3A5263;">' + target.info + '</div>'
        target.infoWindowString += '<a href="' + target.mapUrl + ' "target="_blank" rel="noopener noreferrer">' + "GoogleMapで見る" + '</a>'
      })

      //周辺施設のマーカーを表示
      this.addMarker(this.facilityMakerData,false,this.FACILITY_ICON,this.FLG_FACILITY,true)

      //イベントリスナー設定
      this.facilityMakerList.forEach((marker) => {

        let infowindow = this.makeInfoWindow(marker.infoWindowString)

        // マーカークリックのイベントリスナー
        marker.addListener("click", () => {
          //表示中のInfoWindowを閉じる
          if (this.currentInfoWindow) {
            this.currentInfoWindow.close();
          }
          this.currentInfoWindow = infowindow
          infowindow.open(this.map, marker)
        })
        //MAPの中心位置を岩場にする
        this.setCenter(marker.position.lat(),marker.position.lng())

      })
    },

    //---------------------------------------
    // アプローチ入口マーカーの表示
    //---------------------------------------
    async showApproachPointMaker(){

      //APIから取得したListにInfowindowの値を追加する。
      this.approachPointMakerData.forEach((target) => {
        target.infoWindowString = '<div style="font-size: 1rem; font-weight:bold;">' + target.name + '</div>'
        target.infoWindowString += '<div style="color: #3A5263;">' + target.info + '</div>'
      })

      //アプローチのマーカーを表示
      this.addMarker(this.approachPointMakerData,false,this.APPROACH_POINT_ICON,this.FLG_APPROACH_POINT,true)

      //イベントリスナー設定
      this.approachPointMakerList.forEach((marker) => {

        let infowindow = this.makeInfoWindow(marker.infoWindowString)

        // マーカークリックのイベントリスナー
        marker.addListener("click", () => {
          //表示中のInfoWindowを閉じる
          if (this.currentInfoWindow) {
            this.currentInfoWindow.close();
          }
          this.currentInfoWindow = infowindow
          infowindow.open(this.map, marker)
        })

        //MAPの中心位置を岩場にする
        this.setCenter(marker.position.lat(),marker.position.lng())

      })
    },

    //---------------------------------------
    // アプローチラインの表示
    //---------------------------------------
    async showApproachLine(){

      let coordinatesList = []

      this.approachLineMakerData.forEach((row) => {

        coordinatesList = []

        row.coordinate.forEach((item) => {
          coordinatesList.push(new google.maps.LatLng(item.lat,item.lng))
        })

        //細いライン
        let line1 = new google.maps.Polyline({
          path: coordinatesList,
          strokeColor: this.APPROACH_LINE_STROKE_COLOR,
          strokeOpacity: 1.0,
          strokeWeight: 2
        });
        line1.setMap(this.map);
        //半透明の線
        let line2 = new google.maps.Polyline({
          path: coordinatesList,
          strokeColor: this.APPROACH_LINE_FILL_COLOR,
          strokeOpacity: 0.5,
          strokeWeight: 3
        });
        line2.setMap(this.map);

      })
    },

    //---------------------------------------
    // 入山申請マーカーの表示
    //---------------------------------------
    async showClimberReceptionMakeMaker(){

      //APIから取得したListにInfowindowの値を追加する。
      this.climberReceptionMakerData.forEach((target) => {
        target.infoWindowString = '<div style="font-size: 1rem; font-weight:bold;">' + target.name + '</div>'
        target.infoWindowString += '<div style="color: #3A5263;">' + target.info + '</div>'
      })

      //入山申請のマーカーを表示
      this.addMarker(this.climberReceptionMakerData,false,this.CLIMBER_RECEPTION_ICON,this.FLG_CLIMBER_RECEPTION,true)

      //イベントリスナー設定
      this.climberReceptionMakerList.forEach((marker) => {

        let infowindow = this.makeInfoWindow(marker.infoWindowString)

        // マーカークリックのイベントリスナー
        marker.addListener("click", () => {
          //表示中のInfoWindowを閉じる
          if (this.currentInfoWindow) {
            this.currentInfoWindow.close();
          }
          this.currentInfoWindow = infowindow
          infowindow.open(this.map, marker)
        })

        //MAPの中心位置を岩場にする
        this.setCenter(marker.position.lat(),marker.position.lng())

      })

    },

    createMakerObject(target,isUseAnimation,iconPath){

      //マーカーサイズ
      let markerSize = this.ICON_SIZE_ROCK

      //マーカーの種類に合わせてアイコンサイズをセットする
      if(iconPath == this.CS_ICON || iconPath == this.SPA_ICON || iconPath == this.PARKING_ICON || iconPath == this.RESTROOM_ICON || iconPath == this.FACILITY_ICON){
        markerSize = this.ICON_SIZE_S
      }else if(iconPath == this.APPROACH_POINT_ICON){
        markerSize = this.ICON_SIZE_S
      }else if(iconPath == this.CLIMBER_RECEPTION_ICON){
        markerSize = this.ICON_SIZE_L
      }else if(iconPath == this.ROCKY_ICON){
        markerSize = this.ICON_SIZE_ROCKY
      }

      //座標の値が存在しない場合はエラーを防止するためreturn
      if(target.lat == '' || target.lat == null || target.lat == undefined){
        return null
      }
      if(target.lng == '' || target.lng == null || target.lng == undefined){
        return null
      }
      // 2022/07/07 追加
      let label = {
        text: target.title,
        fontFamily: 'sans-serif',
        fontWeight: 'bold',
        fontSize: '12px'
      }
      // Map種別によってラベルの色を変更する
      const type = this.map.getMapTypeId()
      if(type == 'roadmap' || type == 'GrayScaleMap' || type == 'terrain') {
        label.color = 'black'
      } else {
        label.color = 'white'
      }

      let wkObj = {
        //google.maps.Markerの必須項目
        position:new google.maps.LatLng(target.lat,target.lng),
        icon: {
          url: iconPath,
          scaledSize : markerSize,
          // 2022/07/07 追加
          labelOrigin: new google.maps.Point(10, 40)
        },
        map: this.map,
        //独自設定項目
        id: target.url,
        name: target.title,
        infoWindowString: target.infoWindowString
      }

      // ラベルプロパティを追加
      if(this.isLabelShow) {
        wkObj.label = label
      }

      //アニメーション有りの場合
      if(isUseAnimation){
        // 上部から1度落ちてくるアニメーションを追加する
        wkObj.animation = google.maps.Animation.DROP
      }

      return new google.maps.Marker(wkObj)

    },
    //---------------------------------
    // コンビニと温泉のマーカーList作成
    //---------------------------------
    makeCsSpaList(list,isCs){

      let returnList = []
      //ルート一覧の値をセットする
      returnList = (() => {
        let wkList = []
        list.forEach((target) => {
          // 座標がセットされていない場合はListに追加しない
          if(target.lat == undefined || target.lng == ''){
            return
          }

          let containtStr = ''
          if(isCs){
            containtStr = '岩場から約' + target.distance + 'Km'
          }else{
            containtStr = target.info
          }
          wkList.push({
            lat : target.lat,
            lng : target.lng,
            title: target.name,
            subtitle: '',
            containt: containtStr,
            url: target.url,
            infoWindowString : this.makeInfoWindowHtmlString(target.name,
                                '',containtStr,target.url)
          })
        })
        return wkList
      })()

      return returnList
    },
    //---------------------------------------
    //現在位置表示ボタン
    //---------------------------------------
    makeMyLocationControl(){

      if(document.getElementById("myLocationControl")){
        //既に表示されている場合は何もしない
        return
      }

      var btnDiv = document.createElement('div')
      btnDiv.id = 'myLocationControl'

      //岩場に戻る
      var myLocationBtn = document.createElement('div')

      //地図拡大ボタンの表示(google標準or独自実装)によってstyleを分ける
      if(this.isCustumExpandCtlShow){
        //独自実装の拡大ボタンの場合
        myLocationBtn.style.width = '38px'
        myLocationBtn.style.height = '38px'
        myLocationBtn.style.margin = '50px 1.5rem 10px 10px'
        myLocationBtn.style.borderRadius = '3px'
        myLocationBtn.style.color = 'rgb(170, 170, 170)'
      }else{
        myLocationBtn.style.width = '40px'
        myLocationBtn.style.height = '40px'
        myLocationBtn.style.margin = '0 10px 10px 10px'
        if(this.$route.path == '/rocky/map_search'){
          myLocationBtn.style.margin = '10px 10px 10px 10px'
        }
        myLocationBtn.style.borderRadius = '2px'
        myLocationBtn.style.color = '#666666'
      }

      myLocationBtn.style.backgroundColor = '#FFFFFF'
      myLocationBtn.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px'
      myLocationBtn.style.border = '1px solid #cfd3d7'
      myLocationBtn.style.cursor = 'pointer'
      myLocationBtn.style.display = 'flex'
      myLocationBtn.style.justifyContent = 'center'
      myLocationBtn.style.alignItems = 'center'
      myLocationBtn.title = '現在地'
      btnDiv.appendChild(myLocationBtn)

      var myLocationBtnText = document.createElement('div')
      myLocationBtnText.style.paddingTop = '4px'
      myLocationBtnText.innerHTML = '<b><i class="material-icons">my_location</i></b>'
      myLocationBtn.appendChild(myLocationBtnText)

      btnDiv.index = 2
      /* カスタムコントロールを地図の左上に配置 */
      this.map.controls[google.maps.ControlPosition.RIGHT].push(btnDiv)

      //ボタン押下のイベントリスナー
      google.maps.event.addDomListener(myLocationBtn, "click", () => {
        //現在地を表示する
        this.myLocationShow()
      })
    },

    //---------------------------------------
    //地図ラベル切り替えボタン
    //---------------------------------------
    makeMyLabelControl(){
      // 既に表示されている場合はテキストカラーを変化させる
      if(document.getElementById("myLabelControl")){
        var labelControl = document.getElementById("myLabelControl")
        var c = labelControl.firstChild
        var text = c.firstChild
        text.style.color = this.isLabelShow ? 'black' : 'gray'
        return
      }

      var btnDiv = document.createElement('div')
      btnDiv.id = 'myLabelControl'

      //岩場に戻る
      var myLabelBtn = document.createElement('div')

      //地図拡大ボタンの表示(google標準or独自実装)によってstyleを分ける
      if(this.isCustumExpandCtlShow){
        //独自実装の拡大ボタンの場合
        myLabelBtn.style.width = '38px'
        myLabelBtn.style.height = '38px'
        myLabelBtn.style.margin = '1px 1.5rem 10px 10px'
        myLabelBtn.style.borderRadius = '3px'
        myLabelBtn.style.color = 'rgb(170, 170, 170)'
      }else{
        myLabelBtn.style.width = '40px'
        myLabelBtn.style.height = '40px'
        myLabelBtn.style.margin = '0 10px 10px 10px'
        if(this.$route.path == '/rocky/map_search'){
          myLabelBtn.style.margin = '10px 10px 10px 10px'
        }
        myLabelBtn.style.borderRadius = '2px'
        myLabelBtn.style.color = '#666666'
      }

      myLabelBtn.style.backgroundColor = '#FFFFFF'
      myLabelBtn.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px'
      myLabelBtn.style.border = '1px solid #cfd3d7'
      myLabelBtn.style.cursor = 'pointer'
      myLabelBtn.style.display = 'flex'
      myLabelBtn.style.justifyContent = 'center'
      myLabelBtn.style.alignItems = 'center'
      myLabelBtn.title = 'ラベル'
      btnDiv.appendChild(myLabelBtn)

      var myLabelBtnText = document.createElement('div')
      myLabelBtnText.style.paddingTop = '4px'
      myLabelBtnText.innerHTML = '<i class="fa fa-font"></i>'
      myLabelBtnText.style.color = this.isLabelShow ? 'black' : 'gray'
      myLabelBtn.appendChild(myLabelBtnText)

      btnDiv.index = 3
      /* カスタムコントロールを地図の左上に配置 */
      this.map.controls[google.maps.ControlPosition.RIGHT].push(btnDiv)

      //ボタン押下のイベントリスナー
      google.maps.event.addDomListener(myLabelBtn, "click", async () => {
        // ラベルを切り替える
        await this.switchLabel()
      })
    },

    //---------------------------------------
    // 地図のフルスクリーン⇔通常表示の制御
    //---------------------------------------
    mapExpand(){

      const ua = navigator.userAgent

      if(!this.$parent.isExpanded){

        //地図を最大表示する
        this.$parent.isExpanded = true
        //スクロールモードを変更
        this.map.gestureHandling = 'greedy'

        //拡大前のMapのheightを保持する
        this.beforeExpandMapHeight = this.$parent.mapHeight
        this.$parent.mapHeight = '100vh'

        let mapEl = document.getElementById('parent-area')

        this.scrollY =  mapEl.getBoundingClientRect().top

        //吹き出しをMap最大化の状態用の表示にするため、
        //マーカーActiveのイベントを呼ぶ(岩画面の場合のみ)
        if(this.$route.name == 'rockyInfo_:rockyId_:rockId'){
          this.changeRockMarkerActive()
        }

        if(ua.indexOf('Trident') !== -1) {
          //IE 11の場合はナビがstickyにならないので、上いっぱいまで表示する。
          window.scrollBy(0,this.scrollY)
        }else{
          window.scrollBy(0,this.scrollY-62)
        }

        // PCでのスクロール禁止
        document.addEventListener("mousewheel", this.scroll_control, { passive: false });
        // スマホでのタッチ操作でのスクロール禁止
        document.addEventListener("touchmove", this.scroll_control, { passive: false });

      }else{

        //元のサイズに戻す
        this.$parent.isExpanded = false
        //スクロールモードを変更
        this.map.gestureHandling = 'cooperative'

        //拡大前のMapのheightに戻す
        this.$parent.mapHeight = this.beforeExpandMapHeight

        if(ua.indexOf('Trident') !== -1) {
          //IE 11の場合はナビがstickyにならないので、上いっぱいまで表示する。
          window.scrollBy(0,this.scrollY)
        }else{
          window.scrollBy(0,0 - this.scrollY)
        }

        // PCでのスクロール禁止解除
        document.removeEventListener("mousewheel", this.scroll_control, { passive: false });
        // スマホでのタッチ操作でのスクロール禁止解除
        document.removeEventListener('touchmove', this.scroll_control, { passive: false });

        if(this.$route.name == 'rockyInfo_:rockyId_:rockId'){
          //選択中のマーカーと画面Pathで岩IDが異なる場合は、選択中のマーカーの岩IDのデータを表示する
          if(this.activeRockId !=  this.$route.params.rockId){

            //ルート画面を表示する
            this.$router.push({ 
              name: 'rockyInfo_:rockyId_:rockId', 
              params: { 
                rockyId: this.$route.params.rockyId, 
                rockId:this.activeRockId,
                rockName:this.activeRockName,
                rockyMasterData:this.rockyMasterData,
              }
            })
          }
        }

      }
    },
    //---------------------------------------
    // 現在位置の表示
    //---------------------------------------
    async myLocationShow(){

      let pos
      try {
        //現在位置の座標取得
        pos = await this.getPosition()
        let lat = pos.coords.latitude
        let lng = pos.coords.longitude    

        // マーカーが表示状態なら以前の位置を削除
        if(this.isMyLocationShow && this.currentLocation != null) {
          this.currentLocation.setMap(null);
        }
        //MAPにマーカーを追加する
        let marker = new google.maps.Marker({ 
          //google.maps.Markerの必須項目
          position:new google.maps.LatLng(lat,lng),
          icon: this.MY_LOCATION_ICON,
          map: this.map,
        })
        // 最新の情報を保持
        this.currentLocation = marker
        this.isMyLocationShow = true

        //現在位置をMAPの中心位置にする
        this.setCenter(lat,lng)

      } catch (err) {
        console.log(err)
        await this.asyncDialog('現在地を取得できませんでした。端末、もしくはブラウザの位置情報の許諾に関する設定をご確認ください。')
        return
      }
    },
    //座標取得処理
    getPosition: () => new Promise((resolve, reject) => {
      if (!navigator || !navigator.geolocation) reject()
      navigator.geolocation.getCurrentPosition(
        pos => resolve(pos),
        err => reject(err),
        {
          enableHighAccuracy: true,
          maximumAge: 0,  // 問い合わせのたびに取得
          timeout: 5000
        }
      )
    }),
    makeImgPath(imgPath){
      return this.getRockyThumbPath(imgPath,'360')
    },
    scroll_control(event) {
      event.preventDefault();
    },
    popstateProcess(){
      if(this.$parent.isExpanded){
        this.mapExpand()
        window.history.pushState(null, null, null);
        return
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
#map
  width 100%

#link-button
  color red !important

#map-message
  z-index 1
  top 5%
  left 40% !important
  background #fff
  padding 3px 7px
  border-radius 8px 
  #message
    font-size 0.8rem
    font-weight 600 
    color Red
  #rockName
    font-size 0.7rem
    font-weight bold
    color #004170
  a
    font-size 0.7rem
    font-weight bold
    color #004170
    text-decoration underline

  .level
    font-size 0.6rem

#expand-button
  z-index 1
  top 0
  right 1.5rem !important
  font-size 0.5rem
  padding-top 0.5rem
  button
    width 38px
    height 38px
    padding 0 0.5rem
    border-radius 3px
    font-size 1.2rem
    color rgb(170, 170, 170)
    background #FFF
    box-shadow rgba(0, 0, 0, 0.3) 0px 1px 4px -1px
    border solid 1px #ced4da !important

#location-button
  z-index 1
  top 45px
  right 1.5rem !important
  font-size 0.5rem
  padding-top 0.5rem
  button
    width 38px
    height 38px
    padding 0 0.5rem
    border-radius 3px
    font-size 1.2rem
    color rgb(170, 170, 170)
    background #FFF
    box-shadow rgba(0, 0, 0, 0.3) 0px 1px 4px -1px
    border solid 1px #ced4da !important

</style>
